import { useState, useMemo } from 'react';

export function useSort(data) {
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'ascending'
    });

    const sortedData = useMemo(() => {
        if (!sortConfig.key) return data;

        return [...data].sort((a, b) => {
            // Special handling for ratio
            if (sortConfig.key === 'ratio') {
                const aValue = a.objective && a.price ? a.objective / a.price : 0;
                const bValue = b.objective && b.price ? b.objective / b.price : 0;
                return sortConfig.direction === 'ascending'
                    ? aValue - bValue
                    : bValue - aValue;
            }

            // Numeric columns
            const numericColumns = ['price', 'daily_change', 'five_days_change', 'objective'];
            const isNumeric = numericColumns.includes(sortConfig.key);

            const aValue = isNumeric ? parseFloat(a[sortConfig.key]) : a[sortConfig.key];
            const bValue = isNumeric ? parseFloat(b[sortConfig.key]) : b[sortConfig.key];

            if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
            return 0;
        });
    }, [data, sortConfig]);

    const requestSort = (key) => {
        if (key === 'watchlist' || key === 'remove') return;

        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'ascending'
                ? 'descending'
                : 'ascending'
        }));
    };

    const getSortIndicator = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === 'ascending' ? '↑' : '↓';
    };

    return {
        sortedData,
        requestSort,
        getSortIndicator,
        sortConfig
    };
}